// ============================================
// src/apiConfig.js
// ============================================
// Single source of truth for all API URLs in Spark.
// Shared routes: auth, subscription, account, admin
// Spark routes: profiles, swipes, matches, messages, dates, etc.
//
// Updated 2 May 2026 (Cassiopeia stretch 12) — added env var
// fallback pattern so deployments can override the URL via
// REACT_APP_API_URL without code changes.
//
// Audit: grep -rn 'dating-app-backend-production' src/
// — count should be 1 (this file).
// ============================================

const BASE_URL =
  process.env.REACT_APP_API_URL ||
  'https://dating-app-backend-production-a927.up.railway.app';

export const API_BASE = BASE_URL;
export const API_URL = `${BASE_URL}/api`;
export const SPARK_URL = `${BASE_URL}/api/spark`;
export const SOCKET_URL = BASE_URL;
